export function removeWalletConnectStorage(): void {
  window.localStorage.removeItem("walletconnect") // connected account data
  window.localStorage.removeItem("WALLETCONNECT_DEEPLINK_CHOICE") // connected app's info
}
